import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { cn } from "../../../lib/utils";
import { AttachmentCardList } from "../../../components/Attachment";
const messageBubbleContainerVariants = cva("flex flex-col", {
    variants: {
        role: {
            user: "items-end",
            assistant: "items-start",
            system: "items-start",
        },
    },
});
const messageBubbleVariants = cva("max-w-[70%] rounded-2xl px-4 py-3 shadow-sm mb-5", {
    variants: {
        role: {
            user: "bg-primary text-primary-foreground",
            assistant: "border bg-card text-card-foreground",
            system: "border bg-card text-card-foreground",
        },
    },
});
export const MessageBubble = ({ message, timestampLocale, resolveUrl, onDownload, onPreviewLoad, }) => {
    const hasAttachments = message.attachedFiles && message.attachedFiles.length > 0;
    const hasContent = message.content.trim().length > 0;
    const align = message.role === "user" ? "right" : "left";
    const timestamp = message.createdAt
        ? new Date(message.createdAt).toLocaleString(timestampLocale)
        : undefined;
    return (_jsxs("div", { className: messageBubbleContainerVariants({ role: message.role }), children: [hasAttachments && (_jsx(AttachmentCardList, { files: message.attachedFiles, align: align, className: "max-w-[70%]", resolveUrl: resolveUrl, onDownload: onDownload, onPreviewLoad: onPreviewLoad })), hasContent && (_jsxs("div", { className: cn(messageBubbleVariants({ role: message.role }), hasAttachments ? "mt-2" : "mt-4"), children: [_jsx("div", { className: "whitespace-pre-wrap text-sm leading-relaxed", children: message.content }), timestamp && (_jsx("div", { className: "mt-2 text-xs opacity-70", children: timestamp }))] })), !hasContent && hasAttachments && timestamp && (_jsx("div", { className: "mt-2 text-xs text-muted-foreground opacity-70", children: timestamp }))] }));
};
//# sourceMappingURL=MessageBubble.js.map